import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const SEO = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const isROPage = location.pathname === '/ro' || location.pathname === '/ro/';

  useEffect(() => {
    // Update document title based on page
    const titles = {
      '/': 'Smart Security And RO Systems - CCTV Installation & Security Solutions | Gorakhpur',
      '/cctv': 'Smart Security And RO Systems - CCTV Installation & Security Solutions | Gorakhpur',
      '/ro': 'Smart Security And RO Systems - RO Water Purification Systems | Gorakhpur'
    };

    const descriptions = {
      '/': 'Professional CCTV surveillance systems and security solutions in Gorakhpur. Installation, maintenance, and 24/7 support. Trusted since 2010.',
      '/cctv': 'Professional CCTV surveillance systems and security solutions in Gorakhpur. Installation, maintenance, and 24/7 support. Trusted since 2010.',
      '/ro': 'Professional RO water purification systems in Gorakhpur. Installation, maintenance, and 24/7 support. Clean, pure, safe drinking water. Trusted since 2010.'
    };

    const keywords = {
      '/': 'CCTV installation Gorakhpur, security systems Gorakhpur, surveillance cameras, CCTV maintenance, security solutions, Raptinagar Gorakhpur, Smart Security And RO Systems',
      '/cctv': 'CCTV installation Gorakhpur, security systems Gorakhpur, surveillance cameras, CCTV maintenance, security solutions, Raptinagar Gorakhpur, Smart Security And RO Systems',
      '/ro': 'RO water purifier Gorakhpur, water purification systems, RO installation Gorakhpur, RO maintenance, clean water Gorakhpur, Smart Security And RO Systems'
    };

    const currentPath = location.pathname;
    const title = titles[currentPath] || titles['/'];
    const description = descriptions[currentPath] || descriptions['/'];
    const keyword = keywords[currentPath] || keywords['/'];

    // Update title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Update description
    updateMetaTag('description', description);
    
    // Update keywords
    updateMetaTag('keywords', keyword);

    // Update Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:url', `https://secureflowsystems.com${currentPath}`, true);
    updateMetaTag('og:type', 'website', true);

    // Update Twitter Card tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:url', `https://secureflowsystems.com${currentPath}`);

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://secureflowsystems.com${currentPath}`);

    // Update language attribute
    document.documentElement.lang = language === 'hi' ? 'hi' : 'en';

  }, [location.pathname, language, isROPage]);

  return null;
};

export default SEO;

